// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-message[data-v-0a0dfdd8]{padding:5.5rem 3rem;padding:var(--space-88) var(--space-48)}.error-message p[data-v-0a0dfdd8]{color:#666;color:var(--grey);font-size:1.125rem;font-size:var(--font-size-18);text-align:center;margin-bottom:0}@media (min-width:768px){[data-v-0a0dfdd8]:root{--media-gap:var(--space-8)}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
